module.exports = __webpack_public_path__ + "static/media/l_dermoglam.7bdfc4bc.png";